import {
  IonButton,
  IonCardHeader,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import TrendsCard from "../components/card/TrendsCard/TrendsCard";
import Header from "../components/layout/Header";
import { IoIosPeople } from "react-icons/io";
import { CreateCommunityButton } from "../components/modal/CreateCommunityModal";
import { Helmet } from "react-helmet-async";
import { informationCircleOutline } from "ionicons/icons";
function Trending() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <Header />
        </IonHeader>
        <IonContent>
          {/* <div className="trending">
            <IonCardHeader className="flex align-items-c">
              <IonCardTitle
                className="trending-title"
                style={{ fontFamily: "Poppins, sans-serif" }}
              >
                <IonButton
                  routerLink="/community-faq"
                  fill="clear"
                  style={{
                    fontSize: "1.2rem",
                    color: "#d80621",
                  }}
                >
                  <IonIcon
                    fill="clear"
                    style={{ color: "#d80621", fontSize: "1.2rem" }}
                    icon={informationCircleOutline}
                  />
                </IonButton>
                <IoIosPeople size={24} />
                <div style={{ fontSize: "20px" }}>{t("trendsTitleBig")}</div>
                <CreateCommunityButton />
              </IonCardTitle>
            </IonCardHeader>
            <TrendsCard />
          </div> */}
          <div className="trending">
            <IonCardHeader
              style={{
                padding: "0",
                margin: "0",
                width: "100%",
                boxShadow: "none",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  alignItems: "stretch",
                  width: "100%",
                  backgroundColor: "#ffffff",
                }}
              >
                {/* LEFT COLUMN: INFO */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    padding: "10px 0", // Reduced padding to pull content up
                    minHeight: "80px", // Slightly lower min-height for a tighter look
                  }}
                >
                  <div
                    style={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <IonButton
                      routerLink="/community-faq"
                      fill="clear"
                      style={{
                        margin: "0",
                        "--padding-start": "0",
                        "--padding-end": "0",
                        "--padding-bottom": "0", // Removes hidden bottom padding
                        "--padding-top": "0",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <IonIcon
                        icon={informationCircleOutline}
                        style={{ color: "#d80621", fontSize: "32px" }}
                      />
                    </IonButton>
                  </div>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#4d5464",
                      marginTop: "4px", // Matches center column spacing
                    }}
                  >
                    Info
                  </span>
                </div>

                {/* CENTER COLUMN: COMMUNITIES */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    padding: "10px 0",
                    minHeight: "80px",
                  }}
                >
                  <div
                    style={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <IoIosPeople size={40} style={{ color: "#d80621" }} />
                  </div>
                  <span
                    style={{
                      fontSize: "13px",
                      textTransform: "uppercase",
                      color: "#4d5464",
                      marginTop: "4px",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {t("trendsTitleBig")}
                  </span>
                </div>

                {/* RIGHT COLUMN: CREATE */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    padding: "10px 0",
                    minHeight: "80px",
                  }}
                >
                  <div
                    style={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <CreateCommunityButton />
                  </div>
                  <span
                    style={{
                      fontSize: "14px",
                      color: "#4d5464",
                      marginTop: "4px",
                    }}
                  >
                    Create
                  </span>
                </div>
              </div>
            </IonCardHeader>
            <TrendsCard />
          </div>
        </IonContent>
      </IonPage>
    </>
  );
}

export default Trending;
